import React, { useState } from "react";
import { BiImage } from "react-icons/bi";
import "./index.css";

// Фото объекта с заглушкой: если ссылки нет или картинка не загрузилась
function PropertyImage({ src, alt, className = "" }) {
  const [failed, setFailed] = useState(false);

  return (
    <div className={`property-image ${className}`}>
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <div className="property-image__placeholder">
          <BiImage />
        </div>
      )}
    </div>
  );
}

export const formatPrice = (price, lang) => {
  const num = Number(String(price).replace(/\s/g, ""));
  if (!price || Number.isNaN(num)) return price;
  return num.toLocaleString(lang === "en" ? "en-US" : "ru-RU");
};

export default PropertyImage;
